// import React, { useEffect, useState } from "react";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";

// export const PhoneField = ({
//   label,
//   name,
//   value,
//   onChange,
//   placeholder = "Enter Phone Number",
//   disabled,
//   error,
//   openCountryModal,
//   countryIso,
//   required
// }) => {
//   const [country, setCountry] = useState("in");

//   useEffect(() => {
//     const savedCountry = localStorage.getItem("selectedCountry");
//     const savedDial = localStorage.getItem("selectedDialCode");

//     // Restore selected country flag
//     if (savedCountry) setCountry(savedCountry);

//     // Restore dial code into phone field ONLY if it's empty
//     if (savedDial && !value) {
//       onChange({
//         target: {
//           name,
//           value: savedDial.replace("+", ""), // "91"
//           countryCode: savedDial,            // "+91"
//           phoneNumber: "",
//         },
//       });
//     }
//   }, []);

//   useEffect(() => {
//     if (countryIso && typeof countryIso === "string") {
//       setCountry(countryIso.toLowerCase());
//     }
//   }, [countryIso]);

 
// const formatPhoneWithBrackets = (val, dialCode) => {
//   if (!val || !dialCode) return val;

//   const number =
//     val.startsWith(dialCode) ? val.slice(dialCode.length) : val;

//   return `(+${dialCode}) ${number}`;
// };
// const handlePhone = (val, data) => {
//   if (!val) return;

//   const dial = data?.dialCode || "";
//   const phoneNum =
//     dial && val.startsWith(dial) ? val.slice(dial.length) : val;

//   onChange({
//     target: {
//       name,
//       value: val, // RAW VALUE → 919453343434
//       displayValue: formatPhoneWithBrackets(val, dial), // (+91) 94533434343
//       countryCode: dial ? `+${dial}` : "",
//       phoneNumber: phoneNum,
//     },
//   });
// };

//   return (
//     <div className="space-y-1">
//       {label && (
//         <label className="block text-xs input-lable my-3">{label}{required && <span className="text-red-500">*</span>}</label>
//       )}

//       <div className="relative">
//         <div
//           className="absolute left-3 top-[14px] z-20 w-8 h-6 cursor-pointer"
//           onClick={openCountryModal}
//           disabled={disabled}
//         ></div>

//         <div className={`flex items-center border rounded-[13px] bg-white focus-within:ring-4 ${
//           error 
//             ? 'border-red-500 focus-within:border-red-500 focus-within:ring-red-100' 
//             : 'border-[#E6E2FF] focus-within:border-violet-500 focus-within:ring-violet-500/10'
//         }`}>

//           <PhoneInput
//             country={country}
// value={value?.displayValue || value}
//             onChange={handlePhone}
//             inputProps={{ name, disabled }}
//             enableSearch={false}
//             countryCodeEditable={false}
//             placeholder={placeholder}
//             disabled={disabled}
//             containerClass="!w-full"
//             inputClass="!w-[100%] !border-none !rounded-[13px] !outline-none !shadow-none
//               !text-gray-800 !bg-transparent !px-2 !py-3 !pl-10"
//             buttonClass="!border-none !bg-transparent !p-0 !mr-2 pointer-events-none"
//           />

//         </div>

//         {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
//       </div>
//     </div>
//   );
// };


import React, { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";

export const PhoneField = ({
  label,
  name,
  value,
  countryCode = "",
  onChange,
  placeholder = "Enter Phone Number",
  disabled,
  error,
  openCountryModal,
  countryIso,
  required,
  type = "mobile", // "mobile" | "fixed" | "both"
  rightIcon,
}) => {
  const [country, setCountry] = useState("in");
  const [localError, setLocalError] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  /* ------------------ Restore country ------------------ */
  useEffect(() => {
    const savedCountry = localStorage.getItem("selectedCountry");

    if (savedCountry) setCountry(savedCountry);
  }, []);

  /* ------------------ External country override ------------------ */
  useEffect(() => {
    if (countryIso && typeof countryIso === "string") {
      setCountry(countryIso.toLowerCase());
    }
  }, [countryIso]);

  useEffect(() => {
    if (disabled) {
      setLocalError("");
      return;
    }

    if (error) return;

    const valueDigits = String(typeof value === "object" ? (value?.value || value?.displayValue || "") : (value || "")).replace(/\D/g, "");
    const codeDigits = String(countryCode || "").replace(/\D/g, "");
    const localDigits = codeDigits && valueDigits.startsWith(codeDigits)
      ? valueDigits.slice(codeDigits.length)
      : valueDigits;

    if (!String(localDigits || "").trim()) {
      setLocalError("");
      return;
    }

    const validation = validateNumberType(codeDigits ? `${codeDigits}${localDigits}` : localDigits);
    setLocalError(validation.valid ? "" : validation.error);
  }, [disabled, error, value, countryCode]);

  /* ------------------ Display formatter ------------------ */
  const formatPhoneWithBrackets = (val, dialCode) => {
    if (!val || !dialCode) return val;

    const number =
      val.startsWith(dialCode) ? val.slice(dialCode.length) : val;

    return `(+${dialCode}) ${number}`;
  };

  /* ------------------ Validation logic ------------------ */
const validateNumberType = (rawValue) => {
  try {
    if (!rawValue) {
      return { valid: false, error: "Phone number is required" };
    }

    const phone = parsePhoneNumberFromString(`+${rawValue}`);

    if (!phone || !phone.isValid()) {
      return { valid: false, error: "Invalid phone number" };
    }

    let numberType = phone.getType();
    // getType() may return undefined or a string
    if (!numberType && phone.isValid()) {
      // fallback: treat as valid mobile
      numberType = "MOBILE";
    }
    // Accept FIXED_LINE_OR_MOBILE for both types
    if (type === "mobile") {
      if (["MOBILE", "FIXED_LINE_OR_MOBILE"].includes(numberType)) {
        return { valid: true, numberType };
      } else {
        return { valid: false, error: "Please enter a valid mobile number", numberType };
      }
    }
    if (type === "fixed") {
      if (["FIXED_LINE", "FIXED_LINE_OR_MOBILE"].includes(numberType)) {
        return { valid: true, numberType };
      }
      // If numberType is MOBILE or undefined but phone is valid, accept as landline (for India and similar cases)
      if ((numberType === "MOBILE" || !numberType) && phone.isValid()) {
        return { valid: true, numberType };
      }
      return { valid: false, error: `Please enter a valid landline number (${numberType || "unknown"})`, numberType };
    }
    // If type is both or not specified, accept any valid
    return { valid: true, numberType };
  } catch {
    return { valid: false, error: "Invalid phone number" };
  }
};


  /* ------------------ Handle input ------------------ */
  const handlePhone = (val, data) => {
    const dial = String(data?.dialCode || "").replace(/\D/g, "");
    const typedDigits = String(val || "").replace(/\D/g, "");
    const rawValue = !typedDigits
      ? ""
      : (typedDigits.startsWith(dial) ? typedDigits : `${dial}${typedDigits}`);
    const phoneNum = rawValue && dial && rawValue.startsWith(dial)
      ? rawValue.slice(dial.length)
      : typedDigits;

    if (!typedDigits) {
      setLocalError("");
      const fallbackCountryCode = countryCode || (dial ? `+${dial}` : "");
      onChange({
        target: {
          name,
          value: "",
          displayValue: "",
          countryCode: fallbackCountryCode,
          phoneNumber: "",
          isValid: false,
          numberType: "",
          error: "",
        },
      });
      return;
    }

    // If user cleared all digits and only country code is left, treat as empty state (no error).
    if (!String(phoneNum || "").trim()) {
      setLocalError("");
      onChange({
        target: {
          name,
          value: rawValue,
          displayValue: formatPhoneWithBrackets(rawValue, dial),
          countryCode: countryCode || (dial ? `+${dial}` : ""),
          phoneNumber: "",
          isValid: false,
          numberType: "",
          error: "",
        },
      });
      return;
    }

    const validation = validateNumberType(rawValue, data?.countryCode);

    setLocalError(validation.valid ? "" : validation.error);

    onChange({
      target: {
        name,
        value: rawValue, // RAW → 919812345678
        displayValue: formatPhoneWithBrackets(rawValue, dial), // (+91) 9812345678
        countryCode: dial ? `+${dial}` : "",
        phoneNumber: phoneNum,
        isValid: validation.valid,
        numberType: validation.numberType,
        error: validation.valid ? "" : validation.error,
      },
    });
  };

  /* ------------------ UI ------------------ */
  const valueDigits = String(typeof value === "object" ? (value?.value || value?.displayValue || "") : (value || "")).replace(/\D/g, "");
  const codeDigits = String(countryCode || "").replace(/\D/g, "");
  const localDigits = codeDigits && valueDigits.startsWith(codeDigits)
    ? valueDigits.slice(codeDigits.length)
    : valueDigits;
  const inputValue = codeDigits
    ? (valueDigits && valueDigits.startsWith(codeDigits) ? valueDigits : `${codeDigits}${valueDigits}`)
    : valueDigits;

  return (
    <div className="space-y-1">
      {label && (
        <label className="block text-xs input-lable my-3">
          {label}
          {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <div className="relative">
        <div
          className="absolute left-3 top-[14px] z-20 w-8 h-6 cursor-pointer"
          onClick={openCountryModal}
        />

        <div
          className={`flex relative items-center border rounded-[13px] bg-white focus-within:ring-4 ${
            error || localError
              ? "border-red-500 focus-within:border-red-500 focus-within:ring-red-100"
              : "border-[#E6E2FF] focus-within:border-violet-500 focus-within:ring-violet-500/10"
          }`}
        >
          <PhoneInput
            country={country}
            value={inputValue}
            onChange={handlePhone}
            inputProps={{
              name,
              disabled,
              onFocus: () => setIsFocused(true),
              onBlur: () => setIsFocused(false),
            }}
            enableSearch={false}
            countryCodeEditable={false}
            placeholder={placeholder}
            disabled={disabled}
            containerClass="!w-full"
            inputClass={`!w-full !border-none !rounded-[13px] !outline-none !shadow-none
              !text-gray-800 !bg-transparent !px-2 !py-3 !pl-10 ${rightIcon ? "!pr-10" : ""}`}
            buttonClass="!border-none !bg-transparent !p-0 !mr-2 pointer-events-none"
          />

          {rightIcon && (
            <div className="absolute right-3 top-1/2 -translate-y-1/2 z-20">
              {typeof rightIcon === "string" ? (
                <img src={rightIcon} alt="" className="w-5 h-5" />
              ) : (
                <span className="inline-flex items-center">{rightIcon}</span>
              )}
            </div>
          )}

          {!disabled && !isFocused && !String(localDigits || "").trim() && (
            <span className="pointer-events-none absolute left-[72px] top-1/2 -translate-y-1/2 text-gray-400 text-sm">
              {placeholder}
            </span>
          )}
        </div>

        {(error || localError) && (
          <p className="text-red-500 text-xs mt-1">
            {error || localError}
          </p>
        )}
      </div>
    </div>
  );
};
